export default __webpack_public_path__ + "static/media/img-egt@3x.6beb60a7.png";